import { Component, Input, OnInit } from '@angular/core';
import { LocLabel } from '../clickable-row-table/models/data-table-config.models';

@Component({
  selector: 'app-scrollable-dialog',
  templateUrl: './scrollable-dialog.component.html',
  styleUrls: ['./scrollable-dialog.component.scss']
})
export class ScrollableDialogComponent implements OnInit {
  @Input() headerKey: string | LocLabel = '';
  @Input() close: boolean = true;

  @Input() lighter: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
